/**
 * Bepaalt waar de focus heen moet bij Tab binnen een dialoog.
 * @param count    aantal focusbare elementen in de dialoog
 * @param current  index van het actieve element in die lijst (-1 = niet in de lijst)
 * @param shift    Shift+Tab
 * @param inside   het actieve element ligt binnen de dialoog
 * @returns index om te focussen, -1 = focus de dialoog zelf, null = browser laten afhandelen
 */
export function nextFocusIndex(count: number, current: number, shift: boolean, inside: boolean): number | null {
  if (count === 0) return -1;
  if (!inside || current === -1) return shift ? count - 1 : 0;
  if (shift && current === 0) return count - 1;
  if (!shift && current === count - 1) return 0;
  return null;
}
